export default __webpack_public_path__ + "static/media/leader_notes_detailed.6a364363.pdf";